import React, { useEffect, useState } from 'react';
import { Input, Modal, Button, Card, Tabs, Row, Col, Tooltip, Popconfirm, AutoComplete, Checkbox, Icon, Menu, Collapse, Form, Select, Radio, DatePicker, Spin } from 'antd';
import { compose } from 'recompose';
import * as actions from '../../actions/index';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import '../MyProfile/profile.css';
import Home_Address from '../Inc/Address.js/Home_Address';
import Business_Address from '../Inc/Address.js/Business_Address';
import Vacation_Address from '../Inc/Address.js/Vacation_Address';
import NESA_Address from '../Inc/Address.js/NESA_Address';
import Skeleton from 'react-loading-skeleton';
const TabPane = Tabs.TabPane;
const LoadingIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
const Panel = Collapse.Panel;
const FormItem = Form.Item;
const RadioGroup = Radio.Group;
const customPanelStyle = {
    background: '#fff',
    borderRadius: 16,
    boxShadow : '0 7px 64px 0 rgb(0 0 0 / 7%)',
    marginBottom: 24,
    border: 0,
    overflow: 'hidden',
};

const radioStyle = {
    display: 'block',
    height: '30px',
    lineHeight: '30px',
};



const AlumniAddressForm = (props) => {
    const [state, setState] = useState({
        forceRender: true,
        isInEditMode: false,
        defaultActiveKey: '1',
        ZIPcode: '',
        isPrimary:''
    });

    useEffect(() => {
        props.actions.getAddressTypes()
    }, []);

    const renderAddress = (profileinfo) => {
        const { getFieldDecorator, getFieldValue } = props.form;
        const address = profileinfo.addresses
        const types = props.types
        
        let Home = ''
        let Business = ''
        let Vacation = ''
        let NESA = ''

        if (props.types) {

            const primaryAddress = address.find((k) => k.isPrimary === 'True' );
            const DefaultAddress = (primaryAddress || {}).typeId || '65'
            
            address.map((k, index) => {
                if (k.typeId === "65") {
                    Home = k
                }
                if (k.typeId === "64") {
                    Business = k
                }
                if (k.typeId === "70") {
                    Vacation = k
                }
                if (k.typeId === "68") {
                    NESA = k
                }
            })            

            if (props.types) {
                
                return (
                    <Tabs defaultActiveKey = {DefaultAddress} >
                        <TabPane className='my-profile' tab={<span> HOME { Home ? (Home.isPrimary) === 'True' ? <Tooltip title="Primary Address"><Icon className='margin-left-5' type="check-circle" theme="twoTone" twoToneColor="#52c41a" /></Tooltip> : "" : ""} </span>} key="65">
                            <Home_Address by="admin" />
                        </TabPane>
                        <TabPane className='my-profile' tab={<span> BUSINESS { Business ? (Business.isPrimary) === 'True' ? <Tooltip title="Primary Address"><Icon className='margin-left-5' type="check-circle" theme="twoTone" twoToneColor="#52c41a" /></Tooltip> : "" : ""} </span>} key="64">
                            <Business_Address by="admin" />
                        </TabPane>
                        <TabPane className='my-profile' tab={<span> VACATION { Vacation ? (Vacation.isPrimary) === 'True' ? <Tooltip title="Primary Address"><Icon className='margin-left-5' type="check-circle" theme="twoTone" twoToneColor="#52c41a" /></Tooltip> : "" : ""} </span>} key="70">
                            <Vacation_Address by="admin" />
                        </TabPane>
                        <TabPane className='my-profile' tab={<span> NESA { NESA ? (NESA.isPrimary) === 'True' ? <Tooltip title="Primary Address"><Icon className='margin-left-5' type="check-circle" theme="twoTone" twoToneColor="#52c41a" /></Tooltip> : "" : ""} </span>} key="68">
                            <NESA_Address by="admin" />
                        </TabPane>
                    </Tabs>
                )
            }    
        }
    };

    const renderEditView = () => {
        if (props.profileinfo) {
            return renderAddress(props.profileinfo)
        }
        else {
            return (<Spin indicator={LoadingIcon} className="loading-state" tip="Loading Information..." />)
        }
    };

    return (
        <div>
            <Collapse defaultActiveKey={'1'} accordion style={{ border: 'none', backgroundColor: 'inherit' }}>
                <Panel header="Constituent Address Information" key="1" style={customPanelStyle}>
                    {renderEditView()}
                </Panel>
            </Collapse>
        </div>
    );

};



function mapStateToProps(state) {
    return {
        loading: state.alumniinforeducer.loading, 
        profileinfo: state.alumniinforeducer.profileinfo,
        allstates: state.allstatesreducer.states,
        countries: state.countriesreducer.countries,
        types: state.addresstypesreducer.types,
        Addressloading: state.homeaddressreducer.loading,
        HomeAddress: state.homeaddressreducer.address,
        updating: state.alumniaddressupdatereducer.loading,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    };
}
const AlumniAddress = Form.create()(AlumniAddressForm);

export default compose(connect(mapStateToProps, mapDispatchToProps), withRouter)(AlumniAddress);



// WEBPACK FOOTER //
// ./src/components/MaintainAlumni/alumniAddress.js